export default {
  'm': {
    'uploading': '上傳中...',
    'upload_failed': '上傳失敗',
    'EnterID': '點擊輸入 BuzzCast ID',
    'select-specifications': '點擊選擇充值規格',
    'check-account': '核對充值賬號',
    'whatID': '什麼是 BuzzCast ID ？',
    'getID': '輸入 BuzzCast ID',
    'maskgetID': '輸入 BuzzCast ID',
    'toastTips-format-error': '輸入格式有誤',
    'toastTips-no-exist': '該ID不存在',
    'toastTipsPlease': '請先核對充值賬號',
    'common-problem': '常見問題',
    'transaction-succeeded': '交易成功',
    'transaction-failed': '交易失敗',
    'transaction-cancel': '交易取消',
    'whether-account': '1.我充值後怎麼查看是否到賬？',
    'answer-whether-account': '充值後可回到 APP 的【我的】-【錢包】中查看鑽石',
    'no-account': '2.充值後若是沒有到賬怎麼辦？',
    'answer-no-account': '請在 APP 的【消息】-【官方消息】-【反饋與幫助】中提交您的問題，並提供以下信息，我們的客服將為您提供幫助。',
    'recharge-money': '1.充值金額和賬戶ID',
    'recharge-time': '2.充值的時間和日期',
    'recharge-shot': '3.支付成功的屏幕截圖',
    'recharge-wrong': '3.充錯賬戶，充錯金額怎麼辦',
    'answer-recharge-wrong': '請您在輸入支付密碼前，務必仔細確認充值賬戶 ID 和充值金額信息後再進行購買。錯充金額無法退還，錯充賬戶您可嘗試與實際充值的 ID 用戶聯繫，與對方協商是否願意補償您的充值',
    'refund': '4.退款',
    'answer-refund': '抱歉！ BuzzCast 目前不支持任何形式的退款。',
    'buy-enter-link': '購買鑽石可通過鏈接進行充值，<a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> 將鏈接複製在手機瀏覽器中打開，進入購買頁面，核對賬號後，選擇相應的規格並使用合適的支付方式進行支付即可～優惠多多！',
    'buy-notice-a': '注意: <a>{msg}</a> 是 BuzzCast 唯一官方購買鑽石網址',
    'replace': '更換',
    'sureBtn': '確定',
    'pay-style': '選擇支付方式',
    'goBack': '回到首頁',
    'toastTips': '輸入 BuzzCast ID',
    'rechargeFAQ_title': '常見問題',
    'PayStatusSuccess_title': '交易成功',
    'PayStatusFail_title': '交易失敗',
    'PayStatusCancel_title': '交易取消',
    'Diamonds_title': '{msg} 鑽石充值官方網站',
    'buy-notice': '注意  pay.buzzcast.info 是 BuzzCast 唯一官方購買鑽石網站，客服諮詢請進入【消息】-【官方消息】-【反饋與幫助】',
    'RechargeHelp_title': '充值幫助',
    'feedback_and_help': '反饋與幫助',
    'problem_screenshot': '問題截圖/錄屏（{msg}）',
    'problem_description': '問題描述',
    'problem_description_placeholder': '請描述您遇到的問題',
    'optional': '選填',
    'required': '必選',
    'openAPP': '打開 BuzzCast APP',
    'buy-diamonds-tit': '購買鑽石服務',
    'description': 'BuzzCast 唯一官方鑽石充值網站 ， BuzzCast 是一款國際化社交軟件，全球超過150多個國家和地區的用戶正在使用 BuzzCast',
    'keywords': 'BuzzCast 充值,BuzzCast 鑽石充值,BuzzCast 官方充值,BuzzCast 官方充值網站',
    'wxPay': '請確認微信支付是否已完成',
    'Completed': '已完成支付',
    'failedPay': '支付遇到問題,重新支付',
    'toastTips-no-complete': '支付未完成，請重新支付',
    'payforType': '充值方式',
    'trueText': '確定',
    'falseText': '取消',
    'alertShowTxt1': '确定用',
    'alertShowTxt3': '充值',
    'alertShowTxt5': '鑽石？',
    'EnterIDTip': '{msg}快速充電',
    'scanLogin': '為了賬戶隱私和安全，請掃碼登錄',
    'scanTip': '"提示：點擊 BuzzCast “個人中心/動態”右上角“掃一掃” ,掃碼登錄，同時支持識別二維碼截圖的方式登錄"',
    'scanVersion': '請升級 BuzzCast 到 %s 版本後掃碼登錄',
    'delAccount': '賬號刪除',
    'logout': '退出',
    'submit': '提交',
    'email_place_holder': '輸入你的郵箱',
    'fill_in_email_address': '請填寫郵箱地址',
    'fill_in_all_required': '請輸入問題描述',
    'order_exception_notice': '溫馨提示：充值訂單異常問題必須提供訂單號或賬單截圖',
    'cannot_read_file': '無法讀取文件',
    'submitting': '提交中...',
    'submit_failed': '提交失敗',
    'contact_email': '聯繫郵箱',
    'provide_email': '請提供您的電子郵箱來接收付款通知',
    'email_address': '電子郵箱地址',
    'sel_country_area': '選擇國家或地區',
    'search_for': '搜索',
    'login': '登錄',
    'scan_login': '掃碼登錄',
    'account_password_error': '手機號或密碼有誤',
    'user_frozen': '該用戶已被凍結',
    'account_no_reg': '賬號未註冊',
    'login_no': '您還沒有登錄',
    'login_after_recharge': '登錄後即可充值',
    'scan_login_lesson': '掃碼登錄教程',
    'scan_login_desc': '掃碼登錄方式可快捷、安全的實現充值網站登錄，下面將從兩種方式分別介紹如何進行掃碼登錄。',
    'scan_login_a_title': '識別二維碼截圖的方式登錄',
    'scan_login_a_p1': '1、更加適合於單台設備使用場景，用戶進入充值網站登錄頁面，點擊選擇“掃碼登錄”，將展示有登錄二維碼的頁面截圖，並保存相冊。 （截圖功能不同設備略有差別，可自行搜索截圖功能操作說明）',
    'scan_login_a_p2': '2、打開 BuzzCast APP，可通過“個人中心”或“動態”功能模塊，點擊右上角“掃一掃”，進入掃碼功能模塊。',
    'scan_login_a_p3': '3、點擊“相冊選取”，並允許相冊權限，選擇已保存的二維碼登錄頁面截圖，系統識別後點擊“登錄”確認按鈕，切回瀏覽器稍作等待，頁面即會自動加載用戶信息。',
    'scan_login_b_title': '掃描二維碼的方式登錄',
    'scan_login_b_p1': '1、更加適合於多台設備使用場景，用戶進入充值網站登錄頁面，點擊選擇“掃碼登錄”',
    'scan_login_b_p2': '2、另一台設備打開 BuzzCast APP，可通過“個人中心”或“動態”功能模塊，點擊右上角“掃一掃”，進入掃碼功能模塊。',
    'scan_login_b_p3': '3、將掃碼框對準掃碼登錄頁面二維碼，系統識別後點擊“登錄”確認按鈕（建議掃碼時設備之間保持一定距離，更便於系統識別），稍作等待頁面即會自動加載用戶信息。',
    'scan_login_lesson_end': '以上是對掃碼登錄的教程指引，希望能夠幫到您。客服諮詢請進入APP端消息-官方消息-反饋與幫助。',
    'or': '或',
    'input_phone_num': '手機號不能為空',
    'input_email': '請輸入郵箱賬號',
    'input_password': '輸入密碼',
    'log_in_using_Facebook': '使用 Facebook 登錄',
    'log_in_using_Google': '使用 Google 登錄',
    'account_or_pwd_error': '賬號或密碼有誤',
    'pay_fail_system_risk': '交易失敗：系統異常',
    'recharge_fail_risk_network': '充值失敗，你可能處於高風險的網路環境下或其他原因。若你需要充值幫助，請向我們回報你的問題。',
    'friendly_tip': '溫馨提示',
    'i_got_it': '我知道了',
    'android_fblogin_tip': '因 Facebook 不再支持 Android 嵌入式瀏覽器上的身份驗證登錄，您在進行該方式登錄時，可能出現無法登錄的情況。若遇到此類無法登錄問題請使用 Chrome 瀏覽器進行訪問。',
    'recharge_tip': '具體到賬鑽石數量以實際充值金額為準',
    'sys_error': '參與人數較多，請稍後重試',
    'charge': '儲值',
    'link_add_mainpage': '將鏈接添加到主屏幕，方便下次充值',
    'click_me_to_add': '點我添加',
    'user_has_delete': '該用戶已註銷',
    'support_contant_whatsapp': '如需要支持請聯繫客服 {msg} App：1924383',
    'buy_balance': '可購買餘額:',
    'official_coin_seller': '官方幣商',
    'paystyle_unavailabel_change_other': '系統異常，該支付方式暫不可用，您可更換其他方式支付。',
    "copied": "已復制",
    "reseller": "幣商",
    "netword_busy_try": "網絡繁忙，請重試",
    "placecommen": '請輸入搜索內容',
    "app_all_v2": '所有',

		"use_phone_login": `使用手機登入`,
		"use_email_login": `使用郵箱登入`,
    "device_is_more": "此設備註冊賬號數已達上限",
    "Operation_failed": "此設備因賬號違規已被永久凍結",
    "connection_fail_retry_feedback": "連線失敗，請確保網路暢通並再次嘗試。若仍遇到錯誤，請向我們回報，我們將第一時間為你解決。",
    "fawry_recharge_failed": "{method} 充值 ${msg} 失敗",
    "feedback": "回饋",
    "problem_feedback": "問題反饋",
    "recommended_recharge_methods": "推薦的充值方式",
    "try_recharge_methods": "請嘗試使用以下方式進行充值，若仍有問題，點擊下方的「{feedback}」與我們取得聯繫",
    "unable_recharge": "無法充值",
    "submitted_successfully": "提交成功",
    "feedback_success_tip": "感謝您的反饋，我們會在24小時內盡快處理",
    "completed": "完成",
    'contact_information': '聯繫方式（選填）',
    'pay_failed': '支付失敗',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_HK.js